import React from 'react';
export function Footer() {
  return <footer className="bg-black py-12 border-t border-gray-900" data-id="element-40">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-41">
        <div className="max-w-3xl mx-auto mb-10 text-left" data-id="element-42">
          <h3 className="text-base font-semibold text-gray-400 mb-4 uppercase tracking-wide" data-id="element-43">
            Descargo de Responsabilidad
          </h3>
          <div className="space-y-4 text-xs sm:text-sm text-gray-500 leading-relaxed" data-id="element-44">
            <p data-id="element-45">
              La Masterclass Gratuita de Tomás Benavidez tiene fines
              exclusivamente educativos. Las estrategias y resultados
              compartidos se basan en mi experiencia y en casos reales de
              alumnos, pero no garantizan resultados específicos, ya que estos
              dependen del compromiso, la ejecución y las circunstancias de cada
              persona.
            </p>
            <p data-id="element-46">
              La información brindada no constituye asesoramiento financiero,
              legal o profesional. Tomás Benavidez y su equipo no se
              responsabilizan por las decisiones o resultados obtenidos al
              aplicar el contenido de esta Masterclass.
            </p>
            <p data-id="element-47">
              Todo el material compartido está protegido por derechos de autor y
              es únicamente para uso personal. Queda prohibida su reproducción,
              distribución o comercialización sin autorización.
            </p>
            <p data-id="element-48">
              <strong className="text-gray-400" data-id="element-49">IMPORTANTE:</strong> Esta
              Masterclass no está afiliada ni respaldada por Meta Platforms,
              Inc. (Facebook e Instagram).
            </p>
          </div>
        </div>

        <div className="text-sm text-gray-500 text-center border-t border-gray-900 pt-8" data-id="element-50">
          Copyright © 2026 Tomás Benavidez
        </div>
      </div>
    </footer>;
}